var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5108_46218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4949 25.6681C6.58875 25.6681 0.938232 20.0176 0.938232 13.1114C0.938232 6.2052 6.58875 0.554688 13.4949 0.554688C20.4011 0.554688 26.0516 6.2052 26.0516 13.1114C26.0516 20.0176 20.4011 25.6681 13.4949 25.6681ZM13.4949 2.12428C7.42586 2.12428 2.50782 7.04232 2.50782 13.1114C2.50782 19.1805 7.42586 24.0985 13.4949 24.0985C19.564 24.0985 24.482 19.1805 24.482 13.1114C24.482 7.04232 19.564 2.12428 13.4949 2.12428Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1979 13.1117C19.1979 12.3792 18.6224 11.8037 17.8899 11.8037C17.1574 11.8037 16.5819 12.3792 16.5819 13.1117C16.5819 13.8442 17.1574 14.4197 17.8899 14.4197C18.6224 14.4197 19.1979 13.8442 19.1979 13.1117ZM7.79224 13.1117C7.79224 12.3792 8.36775 11.8037 9.10023 11.8037C9.8327 11.8037 10.4082 12.3792 10.4082 13.1117C10.4082 13.8442 9.8327 14.4197 9.10023 14.4197C8.36775 14.4197 7.79224 13.8442 7.79224 13.1117ZM13.4951 20.0702C10.7745 20.0702 9.3095 18.239 9.20486 18.1344C8.94327 17.8205 8.99559 17.2973 9.3095 17.0357C9.62342 16.7741 10.1466 16.8264 10.4082 17.1403C10.4605 17.1926 11.5069 18.4483 13.4428 18.4483C15.3786 18.4483 16.4773 17.1403 16.4773 17.1403C16.7389 16.8264 17.2621 16.7741 17.576 17.0357C17.8899 17.2973 17.9422 17.8205 17.6806 18.1344C17.6806 18.239 16.2157 20.0702 13.4951 20.0702Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5108_46218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1134,
    height: 25.1134,
    fill: "white",
    transform: "translate(0.938232 0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/Emoji.9d5b88c01afad27971097a527ca85a4c.svg";
export { ForwardRef as ReactComponent };